





































































































































































































































































import { AddressBridge } from '@/views/address/bridge'
import { AliyunCaptcha } from '@/sdk/aliyun_captcha'
import {
  apiGroupBuyingTradePreOrder,
  ApiGroupBuyingTradePreOrderRequest,
  apiShoppingCartAdd,
  apiSubscribeCommodityArrivalReminderAdd,
  apiTradeGeneralTradePreOrder,
  ApiTradeGeneralTradePreOrderRequest,
  apiTradeSecKillTradeSeckillConfirmResult,
  apiTradeSecKillTradeSeckillPreOrder,
} from '@/api'
import { computed, onBeforeUnmount } from '@vue/composition-api'
import { defineClassComponent, useNewRoute } from '@/hooks'
import { globalModel } from '@/model'
import { GoodsData } from '../utils'
import { goodsModel } from '../store'
import { goodsProvider } from '../provider'
import { handleGoodsError } from '../exports'
import { ImagePreview } from 'vant'
import { loopUntil, range } from 'vtils'
import { navigateBack, navigateTo, redirectTo } from '@/router'
import { showDialog, submit } from '@/utils'
import { stationBus } from '@/views/station/bus'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        useNewRoute(this.visible)

        onBeforeUnmount(
          stationBus.on('select', item => {
            this.goodsData.value.selfPickupStation = item
          }),
        )
      }

      goodsData = goodsProvider.inject()

      seckillData = computed(() => this.goodsData.value.seckillData)

      visible = computed({
        get: () => this.goodsData.value.skuPicker.visible,
        set: visible => (this.goodsData.value.skuPicker.visible = visible),
      })

      // 点击封面图
      handleCoverClick = () => {
        ImagePreview({
          images: [this.goodsData.value.selectedSku.skuPic],
        })
      }

      // 点击规格值
      handleSpecValueClick = (
        specValue: GoodsData['specList'][0]['values'][0],
        index: number,
      ) => {
        this.goodsData.value.selectedSku =
          this.goodsData.value.getVisibleSkuBySpecValue(specValue, index)
      }

      // 点击到货提醒
      handleNoticeClick = () => {
        submit(async $ => {
          $.start()
          await apiSubscribeCommodityArrivalReminderAdd({
            commodityId: this.goodsData.value.commodityId,
            skuId: this.goodsData.value.selectedSku.skuId,
          })
          await $.success('已添加到货提醒')
        })
      }

      // 点击选择提货点
      handleStationClick = () => {
        this.goodsData.value.noRefresh = true
        navigateTo('StationPick', {
          selectedId: this.goodsData.value.selfPickupStation.id || '',
          availableIds: JSON.stringify(
            this.goodsData.value.selfPickupAddressId,
          ),
        })
      }

      // 点击立即购买
      handleBuyClick = async () => {
        if (
          this.goodsData.value.shipType === 1 &&
          !this.goodsData.value.selfPickupStation.id
        ) {
          showDialog({
            title: '提示',
            message:
              '请选择自提点，货物将会调往您选择的自提点，请你自行前往提货。',
            noCancel: true,
            confirmText: '我知道了',
          })
          return
        }

        // 验证码
        await AliyunCaptcha.showIfNeeded({
          goodsId: this.goodsData.value.commodityId,
        })

        submit(async $ => {
          $.start('正在下单...')

          // 检测商品是否下架
          const goodsStatus = await this.goodsData.value.checkGoodsStatus()
          if (!goodsStatus) {
            await $.fail('商品已下架，看看其他好货吧', 2000)
            navigateBack(2)
            return
          }

          // 拼团下单
          if (this.goodsData.value.skuPicker.action === 'groupBuying') {
            const preOrderRequestData: ApiGroupBuyingTradePreOrderRequest = {
              activityId:
                this.goodsData.value.marketingData.groupBuying.activityId,
              groupOrderId:
                this.goodsData.value.skuPicker.groupBuyingOrderId || '',
              preOrderType: 2 as any,
              skuInfo: [
                {
                  activityId:
                    this.goodsData.value.marketingData.groupBuying.activityId,
                  commodityId: this.goodsData.value.commodityId,
                  count: this.goodsData.value.buyCount,
                  skuId: this.goodsData.value.selectedSku.skuId,
                  sellChannelId: goodsModel.state.销售渠道ID,
                },
              ],
            }
            const data = await apiGroupBuyingTradePreOrder(
              preOrderRequestData,
            ).catch(
              handleGoodsError({
                商品下架: () => navigateBack(2),
                活动结束: () => location.reload(),
                活动不能参与: () => this.goodsData.value.closeSkuPicker(),
              }),
            )
            // 弹窗进行了路由改造，直接 redirect 过去即可
            redirectTo('OrderPlace', {
              type: 'groupBuying',
              data: JSON.stringify(data),
              preOrderRequestData: JSON.stringify(preOrderRequestData),
            })
          }
          // 秒杀下单
          else if (this.goodsData.value.isSeckill) {
            await apiTradeSecKillTradeSeckillPreOrder({
              activityId: this.seckillData.value.activityId,
              preOrderType: 3 as any,
              sessionId: this.seckillData.value.sessionId,
              skuInfo: [
                {
                  activityId: this.seckillData.value.activityId,
                  commodityId:
                    this.seckillData.value.commodityInfo.commodityId,
                  count: this.goodsData.value.buyCount,
                  skuId: this.goodsData.value.selectedSku.skuId,
                  // @ts-ignore
                  sellChannelId: goodsModel.state.销售渠道ID,
                },
              ],
            })
            const res = await loopUntil(
              () => apiTradeSecKillTradeSeckillConfirmResult(),
              res => res.confirmState !== 0,
              {
                retryDelay: range(100, 500, 10),
              },
            )
            if (res.confirmState === 2) return $.fail(res.msg!)
            const data = res.result
            // 弹窗进行了路由改造，直接 redirect 过去即可
            redirectTo('OrderPlace', {
              type: 'seckill',
              data: JSON.stringify(data),
              preOrderRequestData: JSON.stringify({}),
            })
          }
          // 普通下单
          else {
            const currentLocation = await AddressBridge.getCurrentLocation()
            const preOrderRequestData: ApiTradeGeneralTradePreOrderRequest = {
              captchaToken: AliyunCaptcha.getToken(),
              preOrderType: 2 as any,
              deviceId: globalModel.state.currentDeviceId,
              tvHotelId: globalModel.state.tvHotelId,
              tvHotelRoomNo: globalModel.state.tvHotelRoomNo,
              skuInfo: [
                {
                  commodityId: this.goodsData.value.commodityId,
                  count: this.goodsData.value.buyCount,
                  skuId: this.goodsData.value.selectedSku.skuId,
                  sellChannelId: goodsModel.state.销售渠道ID,
                },
              ],
              shipType: this.goodsData.value.shipType,
              selfPickupAddressId:
                this.goodsData.value.selfPickupStation.id || '',
              address: {
                provinceCode: currentLocation.provinceCode,
                cityCode: currentLocation.cityCode,
                areaCode: currentLocation.districtCode,
                detail: currentLocation.detail,
              },
            } as any
            const data = await apiTradeGeneralTradePreOrder(
              preOrderRequestData,
            )
            // 弹窗进行了路由改造，直接 redirect 过去即可
            redirectTo('OrderPlace', {
              type: this.goodsData.value.isDcd ? 'dcd' : 'normal',
              data: JSON.stringify(data),
              preOrderRequestData: JSON.stringify(preOrderRequestData),
              supportIntegral: this.goodsData.value.supportIntegral,
              selfPickupAddressInfo: JSON.stringify(
                this.goodsData.value.selfPickupStation,
              ),
            })
          }

          this.goodsData.value.closeSkuPicker()
        })
      }

      // 点击加入购物车
      handleAddCartClick = () => {
        submit(async $ => {
          $.start('加入购物车中...')
          const location = await AddressBridge.getCurrentLocation()
          await apiShoppingCartAdd({
            commodityId: this.goodsData.value.commodityId,
            quantity: this.goodsData.value.buyCount,
            skuId: this.goodsData.value.selectedSku.skuId,
            sellChannelId: goodsModel.state.销售渠道ID,
            address: {
              provinceCode: location.provinceCode,
              cityCode: location.cityCode,
              districtCode: location.districtCode,
              detail: location.detail,
            },
          })
          this.goodsData.value.skuPicker.callback?.(this.goodsData.value)
          await $.success('加入购物车成功')
        })
      }

      // 点击收藏
      handleFavoriteClick = () => {
        this.goodsData.value.favorite()
      }

      // 点击确认
      handlePureConfirmClick = async () => {
        await this.goodsData.value.skuPicker.callback?.(this.goodsData.value)
        this.goodsData.value.closeSkuPicker()
      }
    },
)
